"use client";

import { useEffect, useRef } from "react";

const FORM_ID = "231423635110139";
const FORM_SRC = `https://form.jotform.com/jsform/${FORM_ID}`;

// Submissions redirect to /thank-you/?from=patientreg, which fires patient_reg.
export default function PatientFormEmbed() {
  const formRef = useRef(null);

  useEffect(() => {
    if (!formRef.current) return;
    const existing = formRef.current.querySelector(`script[src="${FORM_SRC}"]`);
    if (existing) return;
    formRef.current.innerHTML = "";
    const script = document.createElement("script");
    script.src = FORM_SRC;
    script.type = "text/javascript";
    formRef.current.appendChild(script);
  }, []);

  return <div ref={formRef} className="w-full" />;
}
